// LIBRERIE/IMPORTS
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// COMPONENTI
import NotFoundProperty from '../Error/NotFoundProperty';

// CONFIGURAZIONI & TIPI
import { Property } from '../../types/property';
import appConfig from '../../config/appConfig';


interface ImmobiliGridProps {
    properties: Property[];
    loading: boolean;
    error: any;
    basePath: string;
    labelSold: boolean;
}

const ImmobiliGrid: React.FC<ImmobiliGridProps> = ({ properties, loading, error, basePath, labelSold }) => {
    const { t, i18n } = useTranslation();

    if (!loading && !error && properties.length === 0) {
        return <NotFoundProperty />;
    }

    const getPropertyName = (property: Property) => {
        return `${property.tipologyDetails.name}${t('property.inAddress', ' a ')}${property.addressDetails.quartiereName || property.addressDetails.frazioneName || property.addressDetails.comuneName}`;
    };

    const langPrefix = appConfig.integrations.multilang ? `/${i18n.language}` : '';


    return (
        <>
            {properties.map((property: Property) => {
                const propertyName = getPropertyName(property);
                const propertyUrl = `${langPrefix}/${basePath}/${property.id}`;
                return (

                    <div className="col-md-6" key={property.id}>

                        <div className="property-item">

                            <Link to={propertyUrl}>

                                <div className="property-image bg-overlay-gradient-04">

                                    <img
                                        className="img-fluid"
                                        src={property.mainImage}
                                        alt={t('property.card.imageAltBase', 'Immagine proprietà') + ` ${propertyName}`}
                                    />

                                    {labelSold ? (
                                        <div className="property-lable">
                                            <span className="badge badge-md badge-successi">
                                                VENDUTO DA NOI
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="property-lable">
                                            {property.contractDetails?.name && (
                                                <span className="badge badge-md badge-primary">
                                                    {t(`property.contractTypes.${property.contractDetails.name}`, property.contractDetails.name)}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="property-lable-bottom-left"></div>

                                    {property.exclusive && (
                                        <div className="property-esclusiva-box">
                                            <span className="property-esclusiva">{t('property.exclusive', 'Esclusiva')}</span>
                                        </div>
                                    )}

                                </div>

                                <div className="property-details">

                                    <div className="property-details-inner text-center">

                                        <h5 className="property-title">
                                            {property.tipologyDetails.name}{t('property.inAddress', ' a ')}
                                            {property.addressDetails.quartiereName || property.addressDetails.frazioneName || property.addressDetails.comuneName}
                                        </h5>

                                        <p className="property-address mb-2">
                                            <i className="fas fa-map-marker-alt fa-xs"></i>
                                            {property.addressDetails.frazioneName || property.addressDetails.quartiereName ?
                                                `${property.addressDetails.frazioneName || property.addressDetails.quartiereName}, ${property.addressDetails.comuneName} (${property.addressDetails.provinciaSigla ?? ""})`
                                                : property.addressDetails.comuneName ?
                                                    `${property.addressDetails.comuneName} (${property.addressDetails.provinciaSigla ?? ""})`
                                                    : property.addressDetails.provinciaName ?? ''
                                            }
                                        </p>

                                        <ul className="property-info list-unstyled d-flex">
                                            <li className='flex-fill'>
                                                <i className="fas fa-bed mb-1"></i>
                                                <span className='pr-1'>{property.rooms != null && property.rooms !== 0 ? (
                                                    property.rooms) : ''}</span>
                                                <p className="m-0 d-inline-block">
                                                    {property.rooms != null && property.rooms !== '0' ? (
                                                        parseInt(String(property.rooms), 10) === 1 ? t('common.room', 'Camera') : t('common.rooms', 'Camere')
                                                    ) : 'N.D.'}
                                                </p>
                                            </li>

                                            <li className='flex-fill'>
                                                <i className="fas fa-bath mb-1"></i>
                                                <span className='pr-1'>
                                                    {property.bathrooms != null && property.bathrooms !== 0 ? (
                                                        property.bathrooms) : ''}
                                                </span>
                                                <p className="m-0 d-inline-block">
                                                    {property.bathrooms != null && property.bathrooms !== 0 ? (
                                                        property.bathrooms === 1 ? t('common.bathroom', 'Bagno') : t('common.bathrooms', 'Bagni')
                                                    ) : 'N.D.'}
                                                </p>
                                            </li>

                                            <li className='flex-fill'>
                                                <i className="fas fa-expand-arrows-alt mb-1"></i>
                                                <p className="m-0 d-inline-block">
                                                    {property.sqmt != null && property.sqmt !== 0 ? (
                                                        <span>{property.sqmt} m²</span>
                                                    ) : 'N.D.'}
                                                </p>
                                            </li>
                                        </ul>

                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="property-price">
                                                {property.priceDetails.reservedNegotiation
                                                    ? "Tr. riservata"
                                                    : `€ ${new Intl.NumberFormat('it-IT').format(property.priceDetails.price)} 
                                                        ${property.priceDetails.negotiable
                                                        ? `${t('common.negotiable') || ""}`
                                                        : ""}`}
                                            </div>
                                            <ul className="property-listing-actions list-unstyled mb-0">
                                                <li className="property-rif">

                                                    {t('property.reference', 'Rif.')}: {property.ref}
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default ImmobiliGrid;